import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=958629ec&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=958629ec&prod&lang=scss&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=958629ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958629ec",
  null
  
)

export default component.exports